import { ILender } from '@/context/lender';

export interface IPreApprovalResponse extends Response {
    verdict: EPreApprovalVerdicts;
    approvedLenders: ILender[];
    creditScore: number | null;
    creditScorePercentage: number;
    eligibilityScorePercentage: number;
    accuracyScorePercentage: number;
    onePointOneScore: number | null;
    comprehensiveScore: number | null;
    oneScore: number | null;
    illionScore: number | null;
    /*
     * True only when a bureau actually returned. Do NOT substitute a check on
     * creditScore: it defaults to 850 for partners with no preapproval flow,
     * so that would report a credit file nobody pulled.
     */
    creditFileChecked?: boolean;
    error: unknown | null;
}

export enum EPreApprovalVerdicts {
    APPROVED = 'APPROVED',
    REFERRED = 'REFERRED',
    DECLINED = 'DECLINED',
}
